export default __webpack_public_path__ + "static/media/Maritime.4325597a.jpg";